<template>
  <div>
    <div class="page-header page-header-big">
      <parallax
        class="page-header-image"
        style="background-image: url('img/lm.jpeg')"
      >
      </parallax>
      <!-- <div class="content-center">
        <div class="container">
         <h1 class="title">{{welcome}}.</h1>
           <div class="text-center">
            <a href="#pablo" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-facebook-square"></i>
            </a>
            <a href="#pablo" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#pablo" class="btn btn-primary btn-icon btn-round">
              <i class="fab fa-google-plus"></i>
            </a>
          </div>
        </div>
      </div> -->
    </div>
  <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title" id="test">{{$t('welcome')}}</h2>
            <h3 class="title" id="test">{{$t('welcome2')}}</h3>
            <h5   v-html= "$t('countdown')"> 
              
                <!-- <countdown date="2020-02-08 12:00:00"></countdown> -->

            </h5>
            
          </div>
        </div>
         <div class="row">
          <div class="col-md-8 mr-auto ml-auto text-center">
            
            <h5   v-html= "$t('welcome3')"> 
              
                <!-- <countdown date="2020-02-08 12:00:00"></countdown> -->

            </h5>
            
          </div>
        </div>
        <div class="row">
              <div class="col-md-12">
                            <my-gallery></my-gallery>
              </div>
          </div>
            <div class="row">
              <div class="col-md-12 ">
                <blockquote class="blockquote" style="margin:20px">
                  <p class="mb-0">
                      {{$t('foto[0]')}}
                      <br>
                    <badge href="https://photos.app.goo.gl/t7DyiiiSAcGdiwqd9" type="primary"> {{$t('foto[1]')}}</badge>
                    &nbsp; &nbsp;
                    <badge href="https://photos.app.goo.gl/cqw6i8wNbwEQ9xL48" type="primary"> {{$t('foto[2]')}}</badge>
                    &nbsp; &nbsp;
                    <badge href="https://photos.app.goo.gl/DFafBSWZXwrFbyXM6" type="primary"> {{$t('foto[3]')}}</badge>
                    &nbsp; &nbsp;
                    <badge href="https://photos.app.goo.gl/A5vq1Q6GKS2sF3g97" type="primary"> {{$t('foto[4]')}}</badge>
                    &nbsp; &nbsp;
                    <badge href="https://photos.app.goo.gl/Mz46MSgVo2xhUw7A9" type="primary"> {{$t('foto[5]')}}</badge>
                    &nbsp; &nbsp;
                      <badge href="https://photos.app.goo.gl/zpxPEmubaYykKzBq6" type="primary"> {{$t('foto[6]')}}</badge>
                    &nbsp; &nbsp;
                    <badge href="https://photos.app.goo.gl/nBiY8EMp7WMNoqQZ6" type="primary"> {{$t('foto[7]')}}</badge>
                    &nbsp; &nbsp;
                  </p>
                  <footer class="blockquote-footer">Hary Marwell Photography <cite title="Source Title"><a href="http://www.ihary.cz">www.ihary.cz</a></cite></footer>
                </blockquote>              
                </div>
            </div>
          <div class="row">
              <div class="col-md-12 mr-auto ml-auto">
                <h2 class="text-center" id="video">{{$t('ourvideo')}}</h2>
                <Youtube videoId="8JCuQhUlRPk"  />
                  <footer class="blockquote-footer">Michal Šteflovič - videography <cite title="Source Title"><a href="http://michalsteflovic.com/">michalsteflovic.com</a></cite></footer>

              </div>
            </div>
         
           
        <div class="separator separator-primary"></div>
        <div class="section-story-overview">
          <div class="row">
            <div class="col-md-6">
              <div
                class="image-container image-left"
                style="background-image: url('img/Brno-Cathedral.jpg')"
              >
                <!-- First image on the left side -->
                <p class="blockquote blockquote-primary">
                  
                 
                  
                  <small>{{$t('love')}}</small>
                  
                  <cite> - L.  on M.</cite>

                </p> 
              </div>
              <br>
              <!-- Second image on the left side of the article  -->
              <!-- <div
                class="image-container"
                style="background-image: url('img/Brno-Cathedral.jpg')"
              ></div> -->
            </div>
            <div class="col-md-6 order-1">
               <!-- First image on the right side, above the article  -->
              <div
                class="image-container image-right "
                style="background-image: url('img/MIND.png');
                position: relative;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                      background-repeat: no-repeat;
                      background-size: contain;"
              ></div>
              <h3>
               {{$t('intro_title')}}
              </h3>
              <p class="text-justify" v-html="$t('intro_text')">
                
              </p>
              <p class="text-justify" v-html="$t('intro_text2')">
                
              </p>
              
            </div>
          </div>
       
      <!--dove------------------------------------------------------------------ -->
          <div class="row" id="where">
            <div class="col-md-9 ml-auto mr-auto text-center">
              <h2 class="title" >{{$t('table[0]')}}</h2>
              <div class="table-responsive table-sm">
                  <table class="table">
                    <thead>
                        <tr class="table-primary">
                          <th scope="col"><font-awesome-icon icon="calendar-alt"/> &nbsp; &nbsp;{{$t('table[1]')}}</th>
                          <th scope="col"><font-awesome-icon icon="clock"/> &nbsp;{{$t('table[2]')}}</th>
                          <th scope="col"><font-awesome-icon icon="map-marker-alt"/> &nbsp;{{$t('table[3]')}}</th>
                          <th scope="col"><font-awesome-icon icon="church"/> &nbsp;{{$t('table[4]')}}</th>
                          <th scope="col"><font-awesome-icon icon="utensils"/> &nbsp;{{$t('table[5]')}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{$t('table[6]')}}</td>
                          <td>{{$t('table[7]')}}</td>
                          <td>{{$t('table[8]')}}</td>
                          <td>{{$t('table[9]')}}</td>
                          <td>{{$t('table[10]')}}</td>
                          
                        </tr>
                        
                      </tbody>
                  </table>
            </div>
              <p class="text-justify" v-html="$t('cerimonia')">
                
              </p>
          </div>
          </div>
        
    <!--fine dove------------------------------------------------------------------ -->
    <!--come------------------------------------------------------------------ -->
    <div class="row" id="where">
          <div class="col-md-9 ml-auto mr-auto text-center">
             <h2 class="title"  id="how">{{$t('howTo[0]')}}</h2>
                  <tabs type="primary" tabNavWrapperClasses="col-md-3" tabContentClasses="col-md-6"
                         vertical square class="row text-left" >
                      <tab-pane>
                        <span slot="label" >
                          <font-awesome-icon icon="car" /> &nbsp;{{$t("howTo[1]")}}
                        </span>
                        <p class="text-justify">
                          {{$t("macchina")}}
                        </p>
                        
                             <p>                   
                       <!--     <l-map :zoom="zoom" :center="center">
                              <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                              <l-marker v-for="marker in markers" v-bind:key="marker.id" :lat-lng="marker.position" @add="openPopup">
                                <l-popup :content="marker.text" :options="{ autoClose: false, closeOnClick: false }"></l-popup>
                              </l-marker>
                            </l-map>
                         -->
                         <iframe src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d20857.027542247328!2d16.56822106965855!3d49.19812292660674!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e0!4m5!1s0x4712942cabb1766b%3A0xbe49eebc15340d86!2sHotel%20Santander%2C%20Pis%C3%A1reck%C3%A1%2C%20Pis%C3%A1rky%2C%20Brno%2C%20Repubblica%20Ceca!3m2!1d49.192617299999995!2d16.5633805!4m5!1s0x4712945a5c087d4d%3A0x32fc52b9ed4d128f!2sChiesa%20di%20San%20Tommaso%2C%20Moravsk%C3%A9%20n%C3%A1m.%201%2C%20602%2000%20Brno-st%C5%99ed%2C%20Cechia!3m2!1d49.1979304!2d16.6076546!5e0!3m2!1sit!2sit!4v1572642888454!5m2!1sit!2sit" width="auto" height="450" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                             </p>
                      </tab-pane >
                      <tab-pane>
                        <span slot="label">
                          <font-awesome-icon icon="train" /> &nbsp;{{$t("howTo[2]")}}
                        </span>
                        <p class="text-justify" v-html="$t('treno')"></p>
                        
                      </tab-pane>
                      <tab-pane>
                         <span slot="label">
                          <font-awesome-icon icon="bus-alt" class="text-left"/> &nbsp;{{$t("howTo[3]")}}
                        </span>
                        <p class="text-justify" v-html="$t('bus')"></p>
                        
                      </tab-pane>
                        <tab-pane>
                         <span slot="label">
                          <font-awesome-icon icon="plane-departure"/> &nbsp;{{$t("howTo[4]")}}
                        </span>
                        <p class="text-justify" v-html="$t('aereo')"></p>
                        
                      </tab-pane>
                    </tabs>
          </div>
        </div>
        </div>
        
    <!--fine come------------------------------------------------------------------ -->
    <!-- cosa regalarci---------------------------------------------------------  -->
     <div class="row" id="what">
          <div class="col-md-9 ml-auto mr-auto text-center">
             <h2 class="title" >{{$t('gift')}}</h2>
          
            <p class="text-justify" v-html="$t('wgift')">
              
              
              
              
            </p>
          <!--   <p class="text-justify">
              {{$t("cz_iban")}}
              <br>
              {{$t("it_iban")}}
            </p> -->
          </div>
      </div>
    <!-- fine cosa regalarci --------------------------------------------------- -->
      
      
      </div>
  </div>

    
    <!-- <div class="section text-center">
      <div class="container"> -->
        

    <!--   </div>
    </div> -->
       
    <div class="section section-team text-center">
      <div class="container">
        <h2 class="title" id="team">{{$t('team')}}</h2>
        <div class="team">
          <div class="row">
            <div class="col-md-6">
              <div class="team-player">
                <img
                  src="img/io.jpeg"
                  alt="Martina Barakova"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Martina Barakova</h4>
                <p class="category text-primary">{{$t('marti_desc')}}</p>
                <p class="description">
                  {{$t("marti")}}
                  <!-- <random-chart></random-chart> -->
                </p>
             <!--    <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-instagram"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-facebook-square"></i
                ></a> -->
              </div>
            </div>
            <div class="col-md-6">
              <div class="team-player">
                <img
                  src="img/lei.jpeg"
                  alt="Leonardo Martino"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Leonardo Martino</h4>
                <p class="category text-primary">{{$t('leo_desc')}}</p>
                <p class="description">
                  {{$t("leo")}}
                </p>
               <!--  <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><font-awesome-icon :icon="['fab', 'fa-facebook']" /></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-linkedin"></i
                ></a> -->
              </div>
            </div>
           <!--  <div class="col-md-4">
              <div class="team-player">
                <img
                  src="img/eva.jpg"
                  alt="Thumbnail Image"
                  class="rounded-circle img-fluid img-raised"
                />
                <h4 class="title">Eva Jenner</h4>
                <p class="category text-primary">Fashion</p>
                <p class="description">
                  You can write here details about one of your team members. You
                  can give more details about what they do. Feel free to add
                  some <a href="#">links</a> for people to be able to follow
                  them outside the site.
                </p>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-google-plus"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-youtube"></i
                ></a>
                <a href="#pablo" class="btn btn-primary btn-icon btn-round"
                  ><i class="fab fa-twitter"></i
                ></a>
              </div>
            </div>--> 
          </div>
        </div>
      </div>
    </div> 
    <div class="section section-contact-us text-center">
      <form id="form" @submit="onSubmit" method="post">

        <div class="container" id="rsvp">
          <h2 class="title">{{$t('rsvp_title')}}</h2>
          <p class="description">{{$t('rsvp_desc')}}</p>
          <div class="row">
          
            
            <div class="col-lg-6 text-center ml-auto mr-auto form-group" v-if="!form.no" transition='expand'>
              <n-checkbox class="input-lg" v-model="form.si" :checked="false">{{$t('rsvp_yes')}}</n-checkbox>
            </div>
            <div class="col-lg-6 text-center ml-auto mr-auto form-group" v-if="!form.si" transition='expand'>
              <n-checkbox class="input-lg" v-model="form.no" :checked="false">{{$t('rsvp_no')}}</n-checkbox>
            </div>
          </div>
          <div class="row" v-if="form.no" transition='expand'>
            <div class="col-lg-12 text-center ml-auto mr-auto">
              <p>{{$t('rsvp_sorry')}}
            </p>
            </div>

          </div>
          <div class="row animated" v-if="form.si"  transition="bounce">
                      <div class="col-lg-12 text-center ml-auto mr-auto">

            <p v-html="$t('rsvp_happy')">
            </p>
                      </div>
                
              <fg-input
                class="input-lg"
                v-bind:placeholder="$t('rsvp_name')"
                v-model="form.firstName"
                addon-left-icon="now-ui-icons users_circle-08"
                required
              >
              </fg-input>
                <fg-input  class="input-lg"
                    v-model="form.numbers"
                    v-bind:placeholder="$t('rsvp_number')"
                    value="2"
                    type="number"
                    addon-left-icon="now-ui-icons users_circle-08">
          
          </fg-input>
        <div class="col-lg-8 text-left ml-auto mr-auto">
              <n-checkbox class="input-lg" v-model="form.host" :checked="false">{{$t('rsvp_host')}}</n-checkbox>
              <hr v-if="!form.host">
        </div>
        
            <div class="col-lg-6 text-center ml-auto mr-auto form-group" v-if="form.host">
              <n-checkbox class="input-lg" v-model="form.seven" :checked="false">{{$t('rsvp_seven')}}</n-checkbox>
              <n-checkbox class="input-lg" v-model="form.eight" :checked="false">{{$t('rsvp_eight')}}</n-checkbox>

            </div>
            <div class="col-lg-8 text-left ml-auto mr-auto">
              <n-checkbox class="input-lg" v-model="form.veg" :checked="false">{{$t('rsvp_veg')}}</n-checkbox>
              <hr v-if="!form.veg">
        </div>
          <fg-input  class="col-lg-6 text-left ml-auto mr-auto"
          v-if="form.veg"
                    v-model="form.veg_n"
                    v-bind:placeholder="$t('rsvp_veg_n')"
                    value="1"
                    type="number"
                    addon-left-icon="now-ui-icons users_circle-08">
          
          </fg-input>
          <div class="col-lg-8 text-left ml-auto mr-auto">
              <n-checkbox class="input-lg" v-model="form.cel" :checked="false">{{$t('rsvp_cel')}}</n-checkbox>
              <hr v-if="!form.cel">
        </div>
          <fg-input  class="col-lg-6 text-left ml-auto mr-auto"
          v-if="form.cel"
                    v-model="form.cel_n"
                    v-bind:placeholder="$t('rsvp_cel_n')"
                    value="1"
                    type="number"
                    addon-left-icon="now-ui-icons users_circle-08">
          
          </fg-input>
          <div class="col-lg-8 text-left ml-auto mr-auto">
              <n-checkbox class="input-lg" v-model="form.baby" :checked="false">{{$t('rsvp_baby')}}</n-checkbox>
              <hr v-if="!form.baby">
        </div>
          <fg-input  class="col-lg-6 text-left ml-auto mr-auto"
          v-if="form.baby"
                    v-model="form.baby_n"
                    v-bind:placeholder="$t('rsvp_baby_n')"
                    value="1"
                    type="number"
                    addon-left-icon="now-ui-icons users_circle-08">
          
          </fg-input>
          <fg-input  class="col-lg-12 text-left ml-auto mr-auto"
          
                    v-model="form.altro"
                    v-bind:placeholder="$t('rsvp_altro')"
                    value=""
                    type="text"
                    addon-left-icon="now-ui-icons users_circle-08">
          
          </fg-input>
              
              
              <div class="textarea-container col-lg-11 text-left ml-auto mr-auto">
                <textarea
                  class="form-control"
                  name="name"
                  rows="4"
                  cols="80"
                  v-model="form.message"
                  v-bind:placeholder="$t('rsvp_con')"
                ></textarea>
              </div>
              <div class="send-button">
                <n-button type="submit" @click="onSubmit" round block size="lg"
                  >{{$t('rsvp_send')}}</n-button
                >
  
              </div>
              
            
            
          </div>
        </div>
      </form>
        <div class="col-lg-12 text-justify text-success ml-auto mr-auto" v-if="sent" transition='expand'>
              <p>{{$t("thanks")}}</p>
          </div>
    </div> 
    
   
  </div>
  
</template>
<script>
const querystring = require("querystring");


import { Button, Badge, FormGroupInput,Checkbox, Tabs, Card,TabPane } from '@/components';
import Countdown from '../components/Countdown.vue';
import myGallery from '../components/myGallery.vue';
import Youtube from "../components/Youtube.vue";
import RandomChart from '../components/Charts/RandomChart.vue';
/* import {LMap, LTileLayer, LMarker, LPopup} from 'vue2-leaflet' */


export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [Badge.name]: Badge,
    [FormGroupInput.name]: FormGroupInput,
    [Checkbox.name]: Checkbox,
    Countdown,
    myGallery,
    RandomChart,
    Card,
    Tabs,
    TabPane,
    Youtube
   /*  LMap,
    LTileLayer,
    LMarker,
    LPopup */
    
  },
  data() {
    return {
      videoId:'8JCuQhUlRPk',
      sent: false,
      form: {
        firstName: '',
        email: '',
        message: '',
        si:false,
        no:false,
        numbers:'',
        host:false,
        seven:false,
        eight:false,
        veg:false,
        veg_n:'',
        cel:false,
        cel_n:'',
        baby:false,
        baby_n:'',
        altro:''
        
      },
      /* map:null,
      tabMaps:[],
      zoomControl: false,
      attributionControl: false,
      zoom:13,
      center: L.latLng(49.1945619,16.5965591),
      url:'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      markers: [
      	{
          id:"0",
          position: L.latLng(49.1945619,16.5965591),
          text:  this.$i18n.t('table[9]')
        },
        {
          id:"1",
          position: L.latLng(49.1926016, 16.5634350),
          text: this.$i18n.t('table[10]')
        },
     ] */
     
     
      

     
                  
                
      
     
  
    };
  },
  methods: {
      onSubmit(e) {
          e.preventDefault();
          console.log(this.form)
           this.$axios
             .post(
                 "https://leomarti2020.eu/mail.php",
                  querystring.stringify(this.form)
             )
             .then(res => {
                 this.sent = true;
             }) ;
      }
      
    /* openPopup: function (event) {
      this.$nextTick(() => {
          event.target.openPopup();
      }) 
    }*/
    // invalidateSize: function(tabIndex) {
     
     /*  setTimeout(() => {
        if (typeof tabIndex === "number") {
          this.tabMaps[tabIndex].invalidateSize();
        } else {
          // invalidate all maps
          this.tabMaps.forEach(map => {
            map.invalidateSize();
          });
        }
      }, 10); */
     
  },
  
  mounted() {
    /* this.map = L.map('map').setView([49.1979304,16.6054659], 19);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
    var marker = L.marker([49.1979304,16.6054659]).addTo(this.map);
    
    marker.bindPopup(L._("table[9]"));


    this.tabMaps.push(this.map); // 0 */
    //this.invalidateSize();
          //setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 20);

  }
 
};
</script>
<style></style>

